<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">删除子账号信息</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			subaccount_del接口提供了删除某个子账号的功能，该账号下的子账号与所有项目同时被删除。
		</p>
		<h3 class="doc_main_h3">调用URL</h3>
		<pre class="doc_main_pre"><code class="doc_main_code"><a href="https://skfrm.cn/APIV2/subaccount_del">https://skfrm.cn/APIV2/subaccount_del</a></code></pre>		
        <h3 class="doc_main_h3">请求参数</h3>
		<!--<frm-Request-parameters :propsTableData="frmRequestParams"></frm-Request-parameters>-->
        <h3 class="doc_main_h3">返回值说明</h3>
		<!--<frm-Return-value :propsTableData='frmReturnvalue'></frm-Return-value>-->
		<h3 class="doc_main_h3">通用错误码</h3>
		<!--<frm-Error-Code :propsTableData='frmErrorCode'></frm-Error-Code>-->
		<h3 class="doc_main_h3">返回值示例</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">成功：
	{
		"error_code ":"0",
		"error_msg":"success",
		"subaccount_id":"202",
		"subaccount_token":"40ac368d71f564568bf42d6d4354bf53"
	}
失败：
	{
		"error_code":"1",
		"error_msg":"fail"
	}
</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	import FrmRequestParamsTable from'../../../../components/frmRequestParamsTable';
	import FrmReturnvalueTable from '../../../../components/frmReturnvalueTable';
	import FrmErrorCodeTable from '../../../../components/frmErrorCodeTable';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
			'frm-Request-parameters':FrmRequestParamsTable,
			'frm-Return-value':FrmReturnvalueTable,
			'frm-Error-Code':FrmErrorCodeTable,
		},
		data(){
			return{
				isPathData:['FRM API-v2','子账号管理','删除子账号信息'],				
				frmRequestParams:[
					{"require":"是","name":"account_name","type":"string","msg":"账号名称"},
					{"require":"是","name":"password","type":"string","msg":"账号密码"},
					{"require":"是","name":"verification","type":"string","msg":"验证码（注：需要传递cookie）"},
				],
				frmReturnvalue:[
					{"Parameter":"error_code","name":"string","msg":"0 成功  1 失败"},
					{"Parameter":"error_msg","name":"string","msg":"成功返回 success  失败返回 fail"},
					{"Parameter":"account_id","name":"string","msg":"账号id"},
					{"Parameter":"account_name","name":"string","msg":"账号名称"},
					{"Parameter":"token","name":"string","msg":"token"},
					{"Parameter":"data","name":"array","msg":"项目详细信息列表project_id string  项目id project_name  tring  项目名"},
				],
				frmErrorCode:[
					{"Statuscode":"1004","errormessage":"验证码为空","msg":"验证码不能为空"},
					{"Statuscode":"1005","errormessage":"验证码无效","msg":"验证码错误"},
					{"Statuscode":"1006","errormessage":"账号已被禁用","msg":"账号已被禁用"},
					{"Statuscode":"1008","errormessage":"密码不正确","msg":"密码不正确"},
					{"Statuscode":"1009","errormessage":"账号名称不存在","msg":"账号名称不存在"},
				],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/FRMAPIVTOW/Subaccountmanagement/Deletesubaccountinformation.vue